import { Grid, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import { fetchExperienceProjects } from '../../../api/experience';
import { COLORS } from '../../../constants/colors';
import { EXPERIENCE } from '../../../constants/props';
import useFetch from '../../../hooks/useFetch';
import Project from '../../project/view';

const useStyles = makeStyles({
  root: {
    '&:first-of-type': {
      marginTop: '1.3125rem',
    },
    '&:not(:last-child)': {
      marginBottom: '2.5rem',
    },
  },
  border: {
    height: '3.9375rem',
    width: '.75rem',
    marginRight: '1.25rem',
    backgroundColor: COLORS.primary.main,
    borderRadius: '.3125rem',
  },
  company: {
    fontSize: '1.5rem',
    fontWeight: 'bold',
    lineHeight: '150%',
  },
  detail: {
    fontSize: '1.25rem',
    lineHeight: '150%',
  },
  position: {
    marginTop: '1.375rem',
    marginLeft: '2rem',
  },
  role: {
    fontSize: '1.5rem',
    lineHeight: '150%',
    marginBottom: '0.625rem',
  },
});

const Experience = ({ hash, company, since, until }) => {
  const classes = useStyles();
  const { result: projectsByPosition } = useFetch(
    fetchExperienceProjects,
    hash,
    [hash]
  );

  return (
    <Grid className={classes.root} container direction="row">
      <Grid className={classes.border} item />
      <Grid item container direction="column" xs justify="center">
        <Typography className={classes.company} variant="subtitle1">
          {company}
        </Typography>
        <Typography
          className={classes.detail}
          variant="subtitle2"
        >{`${since} - ${until}`}</Typography>
      </Grid>
      {Array.isArray(projectsByPosition) &&
        projectsByPosition.map(({ role, projects }, index) => (
          <Grid
            className={classes.position}
            key={`position-${index}`}
            container
          >
            <Grid item>
              <Typography className={classes.role} variant="h6" component="h3">
                {role}
              </Typography>
            </Grid>
            <Grid item container direction="column">
              {projects.map((project) => (
                <Project key={project.hash} {...project} />
              ))}
            </Grid>
          </Grid>
        ))}
    </Grid>
  );
};

Experience.propTypes = {
  EXPERIENCE,
};

export default Experience;
